"use client";

import React from "react";
import Image from "next/image";
import GlobalPresenceDesktop from "./GlobalPresenceDesktop";
import GlobalPresenceMobile from "./GlobalPresenceMobile";

const GlobalPresence = () => {
  return (
    <>
      <div className="w-full bg-white md:py-16 py-8 relative">
        <Image
          src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-course/blue-tri.webp"
          alt="bg"
          className="absolute bottom-0 right-0 z-[0]"
          width={640}
          height={480}
          loading="lazy"
        />

        <div className="main_container mx-auto relative">
          <div className="text-left md:mb-8 mb-6">
            <h2 className="md:text-[32px] text-xl font-semibold tracking-[-1px] text-black leading-tight">
              Our Global{" "}
              <span className="visit_txt pr-1 !tracking-[-1px]">Presence</span>
            </h2>
            <p className="md:text-lg text-sm font-normal text-black md:mt-3 mt-2 md:leading-6 md:pr-8">
              Visit your nearest Miles office to explore opportunities and take
              the next step in your career.
            </p>
          </div>
          <div className="md:block hidden">
            <GlobalPresenceDesktop />
          </div>
          <div className="md:hidden block">
            <GlobalPresenceMobile />
          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalPresence;
